<template>
  <v-hover :key="task_id">
    <v-tooltip top slot-scope="{ hover }" :disabled="$vuetify.breakpoint.smAndDown">
      <v-progress-circular slot="activator" :rotate="-90"
      :value="percentage"
      :size="type ? 40 : 32"
      :color="subtasksQuantity > 0 ? (finalizedQuantity === subtasksQuantity ? 'green' : 'primary') : 'blue-grey'"
      :style="'cursor: pointer!important;font-weight: 900!important;background-color: white; border-radius: 20px;' + (percentage === 100 && hover ? `font-size: ${fontSize - 3}px;` : `font-size: ${fontSize}px;`)"
      :class="(subtasksQuantity > 0 ? '' : 'white--text') + (hover ? ' elevation-5' : '')" 
      @click="() => {$emit('onClick')}"
      >
        <span v-if="subtasksQuantity !== 0">{{(hover ? parseInt(percentage) + '%' : subtasksQuantity)}}</span>
        <span v-else :style="`font-weight: 500; font-size: ${fontSize + (hover ? 10 : 4)}px;`">+</span>
      </v-progress-circular>
      <span class="dica">Adicionar/Listar Subtarefas.</span>
    </v-tooltip>
  </v-hover>
</template>

<script>
  export default {
    props: {
      // fontSize: 12,
      // 1 para tabela, 0 para lista
      type: 0,
      finalizedQuantity: 0,
      subtasksQuantity: 0,
      task_id: null
    },
    data: () => ({
      fontSize: 12
    }),
    mounted () {
      this.fontSize = this.type === 1 ? 16 : 12
    },
    computed: {
      percentage: function () {
        return (this.finalizedQuantity / this.subtasksQuantity) * 100
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PSubtaskProgress.vue